<app-dashboard-sidebar></app-dashboard-sidebar>
<div class="mainContentBlock">

</div>